export default __webpack_public_path__ + "static/media/tablet_dark.e70691f0.png";